import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { DASHBOARD } from "@/constants/testIds";
import { MyScenariosTab } from "@/components/dashboard/MyScenariosTab";
import { MyIncidentsTab } from "@/components/dashboard/MyIncidentsTab";
import { useMyActivity } from "@/hooks/useMyActivity";

export default function Dashboard() {
  const { user } = useAuth();
  const { scenarios, incidents, loading } = useMyActivity(user);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-2">Your Space</p>
      <h1 className="font-display font-extrabold uppercase text-3xl md:text-4xl text-zinc-950 tracking-tight mb-1">Welcome, {user.name}</h1>
      <p className="text-zinc-500 text-sm mb-10">{user.email}</p>

      {loading ? (
        <div className="flex justify-center py-14"><div className="h-8 w-8 border-2 border-zinc-300 border-t-zinc-950 rounded-full animate-spin" /></div>
      ) : (
        <Tabs defaultValue="scenarios">
          <TabsList className="bg-white border border-zinc-200 mb-8">
            <TabsTrigger value="scenarios" data-testid={DASHBOARD.myScenariosTab} className="data-[state=active]:bg-zinc-950 data-[state=active]:text-white font-bold uppercase text-xs">
              My Scenarios ({scenarios.length})
            </TabsTrigger>
            <TabsTrigger value="incidents" data-testid={DASHBOARD.myIncidentsTab} className="data-[state=active]:bg-zinc-950 data-[state=active]:text-white font-bold uppercase text-xs">
              My Reports ({incidents.length})
            </TabsTrigger>
          </TabsList>

          <TabsContent value="scenarios">
            <MyScenariosTab scenarios={scenarios} />
          </TabsContent>

          <TabsContent value="incidents">
            <MyIncidentsTab incidents={incidents} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
